import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTask = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={14}
    fill="currentColor"
    viewBox="0 0 10 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="m4.317 9.2-.903-.918a.6.6 0 0 0-.21-.14.67.67 0 0 0-.47 0 .63.63 0 0 0-.4.6q0 .275.183.458L3.9 10.583q.09.084.195.125.105.042.225.042t.225-.042a.6.6 0 0 0 .188-.125L7.55 7.767a.62.62 0 0 0 .183-.452.6.6 0 0 0-.186-.448.62.62 0 0 0-.45-.184.6.6 0 0 0-.447.184zm-2.922 4.2q-.495 0-.845-.352A1.16 1.16 0 0 1 .2 12.2V1.8q0-.495.353-.847Q.905.6 1.4.6h4.7q.237 0 .452.083.215.084.398.267l2.5 2.5a1.15 1.15 0 0 1 .35.85v7.9q0 .495-.353.848a1.16 1.16 0 0 1-.848.352zM5.8 4V1.8H1.4v10.4h7.2V4.6H6.4a.58.58 0 0 1-.427-.172A.58.58 0 0 1 5.8 4"
    />
  </svg>
);
export default SvgTask;
